module.exports = __webpack_public_path__ + "static/media/about1.b653541b.jpg";